import { fmtDate } from "@/lib/meta";
import {
  StickyNote, Phone, MapPin, Upload, ArrowRightLeft, History, XCircle, Plus, RotateCcw, GitMerge, UserPlus,
} from "lucide-react";

const ICONS = {
  note: StickyNote, call: Phone, site_visit: MapPin, upload: Upload,
  stage_change: ArrowRightLeft, field_revision: History, reject: XCircle,
  created: Plus, reopen: RotateCcw, merge: GitMerge, assigned: UserPlus, restore: RotateCcw,
};

function describe(e) {
  const d = e.data || {};
  switch (e.type) {
    case "stage_change": return `Moved from ${d.from_label || d.from_stage} to ${d.to_label || d.to_stage}`;
    case "field_revision": return `Updated ${(d.field || "").replace(/_/g, " ")}: "${d.old || "—"}" → "${d.new}"`;
    case "reject": return `Rejected — ${(d.code || "").replace(/_/g, " ")}${d.note ? ` (${d.note})` : ""}`;
    case "call": return d.note ? `Call: ${d.note}` : "Logged a call";
    case "site_visit": return d.note ? `Site visit: ${d.note}` : "Logged a site visit";
    case "upload": return d.note || "Uploaded a file";
    case "note": return d.note || "Added a note";
    case "created": return d.note || "Deal created";
    case "reopen": return d.note || "New deal opened";
    case "assigned": return d.note || `Assigned to ${d.rep_name}`;
    case "merge": return d.note || "Merged property";
    case "restore": return d.note || "Restored lead";
    case "lead_deleted": return d.note || "Deleted lead";
    default: return e.type;
  }
}

export default function Timeline({ events }) {
  if (!events || events.length === 0)
    return <div className="text-sm text-gray-400 py-8 text-center" data-testid="timeline-empty">No activity yet.</div>;
  return (
    <div className="relative pl-6" data-testid="timeline">
      <div className="absolute left-[9px] top-1 bottom-1 w-px bg-gray-200" />
      <div className="space-y-4">
        {events.map((e) => {
          const Icon = ICONS[e.type] || StickyNote;
          return (
            <div key={e.id} className="relative" data-testid={`timeline-event-${e.type}`}>
              <div className="absolute -left-6 top-0 h-[18px] w-[18px] rounded-full bg-white border-2 border-[#0047FF] flex items-center justify-center">
                <Icon className="h-2.5 w-2.5 text-[#0047FF]" />
              </div>
              <div className="text-sm text-gray-800">{describe(e)}</div>
              <div className="text-[11px] text-gray-400 mt-0.5">
                {e.actor_name || "System"} · {fmtDate(e.at)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
